import { make_listicle } from "./listicle_template";

let review = make_listicle("bullrun_crypto",19);

export default review;